/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import CollaboratorPage from '/client/src/pages/Events/detail/collaborators';
import SaveBtn from '../saveBtn';
import { withRouter } from 'react-router-dom';
import { ToggleLeftMenu } from '/client/src/utils/animation';

type NewDesignPropsType = {
  onHandleChangeStepNavBar: () => void,
  match: {
    params: {
      eventId?: string | number,
      viewTab?: string
    }
  },
  history: {
    push: (string) => void
  }
};

const NewCollaborators = (props: NewDesignPropsType): React.Fragment => {
  const { match: { params }, onHandleChangeStepNavBar, history } = props;
  const [isShowSaveNextBtn, setShowSaveNextBtn] = React.useState(false);

  React.useEffect(() => {
    ToggleLeftMenu('hide');

    setTimeout(() => {
      setShowSaveNextBtn(true);
    }, 1000);
  }, []);

  return (
    <>
      <CollaboratorPage {...props} isNew onHandleChangeStepNavBar={onHandleChangeStepNavBar} history={history} />
      {isShowSaveNextBtn &&
        <SaveBtn
          handleSave={() => {
            history.push(`/events/new/${params.eventId}/share`);
            onHandleChangeStepNavBar(4);
          }}
          onHandleChangeStepNavBar={onHandleChangeStepNavBar}
          isNew={params.viewTab !== 'edit'}
          text={params.viewTab === 'edit' ? 'Save' : 'Save & Next'}
        />
      }
    </>
  );
};

export default withRouter(NewCollaborators);